import { HotelReserveCardCancellationModal } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal";
import { HotelReservedCardContentPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content/hotel-reserved-card-content.types";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import isBoolean from "lodash-es/isBoolean";
import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
import { memo, useState } from "react";

const Component = (properties: HotelReservedCardContentPropertiesType) => {
  const {
    id,
    title,
    availableRooms,
    rackIncluded,
    extraBed,
    hasBreakfast,
    adults,
    facilities,
    onClick,
    description,
    hasMorContentButton = true,
    freeCancellation,
    cancellationPolicies,
    regularBadges,
    roomCount
  } = properties;
  const router = useRouter();
  const isFull = !availableRooms && !rackIncluded;

  const [open, setOpen] = useState(false);
  const modalProperties = {
    open,
    onClose: () => setOpen(false),
    cancellationPolicies
  };

  const moreContentButton = (isMobile: boolean) => {
    if (hasMorContentButton)
      return (
        <div
          className={`text-body-2 text-secondary cursor-pointer flex-row gap-1 ${
            isMobile ? "flex lg:hidden" : "hidden lg:flex"
          }`}
          onClick={() =>
            onClick?.({
              roomId: id,
              tabSelected:
                facilities?.length && availableRooms
                  ? "facilities"
                  : "roomCalendar",
              availableRooms: availableRooms,
              noRooms: roomCount
            })
          }
        >
          <span className="whitespace-nowrap">
            جزئیات{isFull ? "" : " و قوانین کنسلی"}
          </span>
          <MaterialIcon name="arrow_back_ios" className="text-xs" />
        </div>
      );
  };

  return (
    <div className="flex flex-col">
      {/*Boolean(img) && (
        <div className={"h-[80px] lg:hidden"}>
          <img alt="room" src={img} />
      )*/}
      <div className="flex flex-col gap-4 p-4">
        <div className="flex flex-row justify-between gap-2">
          <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
            {isFull && (
              <MiniChips
                color="error"
                text="ظرفیت تکمیل"
                variant="round-contained"
              />
            )}
            <h3 className="text-on-surface-high-emphasis text-subtitle-2 lg:text-subtitle-1">
              {title}
            </h3>
          </div>
          {moreContentButton(false)}
        </div>
        <div className="flex w-full flex-row flex-wrap gap-1">
          <MiniChips
            StartIcon={<MaterialIcon name="person" />}
            text={`${numberConvert(adults, { locale: router.locale })} نفر`}
            variant="accent"
          />
          {Boolean(hasBreakfast) && (
            <MiniChips
              StartIcon={<MaterialIcon name="local_cafe" />}
              text="با صبحانه"
              variant="accent"
            />
          )}
          {Boolean(extraBed) && (
            <MiniChips
              StartIcon={<MaterialIcon name="hotel" />}
              text="قابلیت تخت اضافه"
              variant="accent"
            />
          )}
          {Boolean(rackIncluded) && (
            <MiniChips
              StartIcon={<MaterialIcon name="event" />}
              color="error"
              text="بازه اقامتی مشخص "
              variant="accent"
            />
          )}
          {isBoolean(freeCancellation) &&
            (freeCancellation ? (
              isEmpty(cancellationPolicies) ? (
                <MiniChips
                  StartIcon={<MaterialIcon name="check" />}
                  color="success"
                  text="کنسلی رایگان"
                  variant="accent"
                />
              ) : (
                <MiniChips
                  className="cursor-pointer"
                  color="secondary"
                  onClick={() => setOpen(true)}
                  text="قوانین کنسلی"
                  variant="text"
                />
              )
            ) : (
              <MiniChips
                StartIcon={
                  <MaterialIcon name="do_not_disturb" variant="outlined" />
                }
                color="error"
                text="غیرقابل استرداد"
                variant="accent"
              />
            ))}
        </div>
        {regularBadges?.map(({ color, icon, text, transparent }) => (
          <span
            className="relative flex h-6 w-fit items-center gap-[6px] whitespace-nowrap rounded-[4px] px-[7px] outline-none"
            key={text}
            style={{
              color: transparent ? color : "white",
              backgroundColor: transparent ? `${color}20` : color
            }}
          >
            {icon && (
              <span className="text-sm">
                <MaterialIcon name={icon} variant="outlined" />
              </span>
            )}
            <span className="text-caption">{text}</span>
          </span>
        ))}
        {Boolean(description) && (
          <span className="text-caption text-on-surface-medium-emphasis flex items-center gap-2 text-justify">
            <MaterialIcon
              className="!overflow-clip text-lg"
              name="bed"
              variant="outlined"
            />
            {numberConvert(description, { locale: router.locale })}
          </span>
        )}
        {moreContentButton(true)}
      </div>
      <HotelReserveCardCancellationModal {...modalProperties} />
    </div>
  );
};

export const HotelReserveCardContent = memo(Component, deepCompare);
